
// frontend/src/pages/Dashboard/Customer/All/index.jsx
import React, { useState } from 'react';
import styles from './index.module.css';
import CustomerTable from './components/CustomerTable';
import CustomerDetail from './components/CustomerDetail';

const AllCustomer = () => {
  const [activeSection, setActiveSection] = useState('all');
  const [selectedCustomerCode, setSelectedCustomerCode] = useState(null);
  const [savedTableState, setSavedTableState] = useState({
    currentPage: 0,
    searchTerm: ''
  });

  const handleCustomerClick = (customerCode, tableState) => {
    console.log('👤 Customer clicked:', customerCode);
    
    // Save current table state
    setSavedTableState(tableState);
    
    // Set selected customer and switch to detail view
    setSelectedCustomerCode(customerCode);
    setActiveSection('detail');
  };

  const handleBackToCustomers = () => {
    console.log('⬅️ Going back to customers list');
    setActiveSection('all');
    // selectedCustomerCode and savedTableState are preserved
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.sectionTabs}>
          <button
            className={`${styles.tabButton} ${activeSection === 'all' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('all')}
          >
            All Customers
          </button>
          <button
            className={`${styles.tabButton} ${activeSection === 'detail' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('detail')}
          >
            Customer Detail
          </button>
        </div>

        {activeSection === 'all' && (
          <div className={styles.sectionContent}>
            <CustomerTable 
              onCustomerClick={handleCustomerClick}
              savedState={savedTableState}
            />
          </div>
        )}

        {activeSection === 'detail' && (
          <div className={styles.sectionContent}>
            <CustomerDetail 
              initialCustomerCode={selectedCustomerCode}
              onBack={handleBackToCustomers}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AllCustomer;